import { DataTexture, Group, Texture } from 'three'
import Sticker from './Sticker'
import App from './App'

type Options = {
	node: HTMLElement
	app: App
	displacementTexture: DataTexture
	normalTexture: Texture
}

class Stickers {
	private readonly node: HTMLElement
	private readonly stickers: Sticker[]
	private readonly app: App
	private readonly group: Group
	private readonly isFixed: boolean = false
	private hasVideos = false

	constructor(options: Options) {
		const { node, app, displacementTexture, normalTexture } = options

		this.node = node
		this.app = app
		this.isFixed = node.dataset.fixed === 'true'

		const config = JSON.parse(node.dataset.config ?? '[]')

		this.group = new Group()

		this.stickers = config.map((config: unknown) => {
			return new Sticker({
				app,
				displacementTexture,
				normalTexture,
				config,
				parent: this.group
			})
		})

		this.app.scene.add(this.group)
	}

	dispose() {
		this.stickers.forEach((sticker) => sticker.dispose())
		this.app.scene.remove(this.group)
	}

	async load() {
		await Promise.all(this.stickers.map((sticker) => sticker.load()))
		this.hasVideos =
			this.stickers.filter((sticker) => sticker.type === 'video' && !sticker.hasVideoFrameCallback).length > 0
	}

	updateVideo() {
		if (this.hasVideos) {
			this.app.requestRender()
		}
	}

	update(): void {
		let y = 0

		const { height: wHeight } = this.app.sizes

		if (this.isFixed) {
			y = this.app.pageYOffset / (wHeight * 5) //600vh - 100vh
		} else {
			const { top, height } = this.node.getBoundingClientRect()
			y = ((top - wHeight) / (height + wHeight)) * -1
		}

		this.stickers.forEach((sticker) => sticker.update(y))
	}
}

export { Stickers }
